import React from "react";

import PropTypes from "prop-types";

import numberFormat from "common/source-function/numberFormat";

import Tooltip from "components/atoms/Tooltip";

import styles from "./Index.module.scss";

const AccountingTab = ({
  accountingService,
  setAccountingValue,
  accountingValue,
  xero,
  setXero,
}) => {
  const transaction = accountingService?.transaction || {};

  return (
    <>
      <div className="mb-6 flex items-center justify-center gap-x-7">
        <input
          className="h-8 w-20 rounded-full border border-bbc-neutral-600 text-center outline-none"
          value={numberFormat(accountingValue)}
          onChange={(e) => setAccountingValue(e.target.value)}
        />
        <p>Transactions per month</p>
      </div>
      <div className="lg:px-6">
        <input
          className={`form-input mb-4 h-1 w-full appearance-none rounded-full bg-bbc-primary focus:shadow-none focus:outline-0 focus:ring-0 ${styles.sfc_slider}`}
          min={transaction.min || 1}
          max={transaction.max || 1000}
          step={transaction.step || 1}
          value={accountingValue}
          onChange={(e) => setAccountingValue(e.target.value)}
          type="range"
        />
        <div className="mb-8 flex justify-between">
          <span>{numberFormat(transaction.min || 1)}</span>
          <span>{numberFormat(transaction.max || 1000)}</span>
        </div>
        <div className="mb-8 flex  flex-row items-center gap-y-3">
          <div className="flex">
            <input
              id="multi-currency"
              type="checkbox"
              className="bbc-checkbox form-input cursor-pointer rounded-full border outline-none ring-0 focus:outline-0 focus:ring-0"
              checked={xero.checked}
              onChange={(e) => setXero(e.target.checked)}
            />
          </div>
          <label
            htmlFor="multi-currency"
            className="mr-2 cursor-pointer select-none pl-1.5"
          >
            Multi-currency Xero accounting{" "}
            {`${accountingService?.currencySymbol}${xero.value}`}/month
          </label>
          <Tooltip
            tooltipText="If your business's revenue or expense arises in 2
                        currencies or above, Xero multiple-currency account
                        would be needed for foreign currency translation. The
                        fee is fixed at USD 25/ month no matter how many foreign
                        currencies you have."
          />
        </div>
        <div className="mb-8 border-t border-neutral-600 border-opacity-40" />
      </div>
    </>
  );
};

export default AccountingTab;

AccountingTab.propTypes = {
  accountingService: PropTypes.object,
  setAccountingValue: PropTypes.func,
  accountingValue: PropTypes.any,
  xero: PropTypes.object,
  setXero: PropTypes.func,
};

AccountingTab.defaultProps = {
  accountingService: {},
  setAccountingValue: () => {},
  accountingValue: "",
  xero: {},
  setXero: () => {},
};
